<a *ngIf="showFAQShortcut" id="faq" pTooltip="FAQ" tooltipPosition="left" style="cursor: pointer; margin-top: -68px;" class="layout-config-button" (click)="goFaq()">
    <i class="pi pi-question-circle"></i>
</a>
